export const OBJECT_TYPE_TABLE_SETTING = 'tableSetting';
export const REMOTE_STORAGE = 'remoteStorage';
export const LOCAL_STORAGE = 'localStorage';
export const NO_STORAGE = 'noStorage';
export const SCOPE_PUBLIC = 'public';
export const SCOPE_PRIVATE = 'private';
export const TABLE_SETTING_STYLE = 'TABLE_SETTING_STYLE';
export const COPY_CODE = 'COPY_CELL';
export const PASTE_CODE = 'PASTE_CELL';
export const FIXED_LEFT_COLUMN = 'FIXED_LEFT_COLUMN';
export const FIXED_RIGHT_COLUMN = 'FIXED_RIGHT_COLUMN';
export const CLEAR_FIXED_COLUMN = 'CLEAR_FIXED_COLUMN';
